/* Loader.js */

import React from 'react';
import './../assets/loader.scss';
import { useAuth } from '../context/auth/AuthContext';

export default function Loader() {
  const { loading } = useAuth();

  return (
    <>
      {loading && <div className='loader_container'><span className='loader'></span></div>}
    </>
  );
}
